import { Component, OnInit, Input, Inject, EventEmitter, ViewChild, Output, Renderer2, HostListener } from '@angular/core';
import { PlanDownloadComponent } from '../../../shared/components/plan-download/plan-download.component';
import { basketVM } from '../../../shared/viewmodels/ISearchServiceReg';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';
import { UnindexSearchService } from '../../unindexed-search-service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
//import { ImageViewerComponent } from '../../../shared/components/ng2-image-viewer';
//import { ImageViewerComponent } from 'ng2-image-viewer';
import { RecSearchService } from '../../../rec-search/rec-search-service';
import { NgxExtendedPdfViewerComponent, PdfBreakpoints, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
//import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-unindexed-record-doc-image',
  providers: [UnindexSearchService, ShoppingBasketService],
  templateUrl: './unindexed-record-doc-image.component.html',
  styleUrls: ['./unindexed-record-doc-image.component.css']
})
export class UnindexedRecordDocImageComponent implements OnInit {

  @Input() book: string;
  @Input() page: string;
  @Input() indexId: string;
  public sBook: string;
  public sPage: string;
  public indexType: string;
  //@Input() indexbook: string;
  //@Input() indexpage: string;
  //@Input() indexgroup: string;
  //@Input() dategroup: number;
  public pageCount: number;
  public currentIndex: number;
  public currentImageIndex: number;
  public docImages: Array<string>;
  @Input() currentImage: Array<string>;
  public blobImage: string;
  public bufferSize: number = 5;
  public isLoadingImage: boolean = true;
  public showimageviewer: boolean = false;
  public isImgVwVisible: boolean = true;
  error: any;
  evtEmitter = new EventEmitter();
  previewImage: any;
  public imgvwr: any;
  public isFirstPage: boolean;
  public isLastPage: boolean;
  @ViewChild(PlanDownloadComponent, { static: false }) docBasketChild;
  basketItem: basketVM;
  collapseGo: boolean = false;
  collapseReturn: boolean = false;
  screenWidth: any;
  @Output() public changeImgVwVisible = new EventEmitter();
  popupVisible: boolean = false;
  Message: string;
  public path: string;
  docId: number;
//  book: string;
//  page: string;
  planImages: Array<string>;
  indexPaths: Array<string>;
  isDocImageView: boolean = false;
  imageFound: boolean = true;
  appurl: string;
  @ViewChild(NgxExtendedPdfViewerComponent, { static: false }) pdfViewer: NgxExtendedPdfViewerComponent;

  constructor(private route: ActivatedRoute,
    private service: UnindexSearchService,
    private router: Router, private renderer: Renderer2, public nav: NavMenuService, private recservice: RecSearchService,
    private sbSvc: ShoppingBasketService, @Inject('BASE_URL') baseUrl: string) {
    this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    this.planImages = new Array<string>();
    this.indexPaths = new Array<string>();
    this.nav.hide();
    this.getScreenSize();
    this.appurl = baseUrl;
    pdfDefaultOptions.maxCanvasPixels = -1;
  }

  /** Initialize image viewer */
  ngOnInit() {
    console.log('uninsdexed-record-doc-image.ngOnInit() fired');
    this.currentIndex = 1;
    this.currentImageIndex = 0;
    this.isLoadingImage = true;
    // this.planImages = new Array<string>();
    console.log("book " + this.book);
    console.log("page " + this.page);

    this.indexType = this.sbSvc.getUnindexedType(this.indexId);

    //this.getIndexPaths(this.indexbook, this.indexgroup, this.indexpage, this.dategroup);
    this.getIndexPaths(this.book, this.page, this.indexId);

    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.sbSvc.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.sbSvc.updateBasketCount(0);
  }

//  getIndexPaths(indexbook, indexgroup, indexpage, dategroup) {
  getIndexPaths(book, page, indexId) {
    //var tp = "";
    var FormattedPage = "";
    //if (dategroup > 100)
    //  tp = "index51";

    //if (tp == "index51")
    //  FormattedPage = ("00000" + indexpage).slice(-5) + ".tif";
    //else if (tp == "index79")
    //  FormattedPage = ("0000" + indexpage).slice(-4) + ".tif";
    //else
//      FormattedPage = "\img_" + ("0000" + page).slice(-4) + ".tif";

//    console.log("FormattedPage" + FormattedPage);
//    this.service.GetIndexPaths(indexbook, indexgroup, indexpage, dategroup).subscribe(

    this.service.GetUnIndexPaths(book, page, indexId).subscribe(
      data => {
        this.indexPaths = data;
        this.pageCount = this.indexPaths.length;
        //this.currentIndex = 1; //this.indexPaths.findIndex(item => item.includes(FormattedPage));
        this.currentIndex = this.pageCount > 0 ? 1 : 0; //this.indexPaths.findIndex(item => item.includes(FormattedPage));
        console.log('CI ' + this.currentIndex + ' pg ' + this.pageCount);
        let pos = 0;
        let index = 0;
        let pg = '';
        let sheet = '';

        if (this.currentIndex === 1)

          //tax books - scroll to page requested
          if (indexId == 29) {
            for (var item of this.indexPaths) {
              pos = item.indexOf('CB');
              pg = item.substring(pos + 7, pos + 11)
              sheet = item.substring(pos + 12, pos + 15)
              if (+pg + +sheet - 1 === +page) {
                this.currentIndex = index + 1;
                break;
              }
              index++;
            }
          }
//        console.log(this.indexPaths[index] + ' ' + index);
        console.log('PG: ' + pg + ' sheet: ' + sheet);
        this.getUnIndexImage2(this.indexPaths[index], 0);
 //       this.getUnIndexImage(this.indexPaths[this.currentImageIndex], 0);
        this.changeNavigationbutton
        this.isLoadingImage = true;
      }
    );


  }

  getUnIndexImage2(path: string, page: number) {
    console.log("unindex2 path and page - " + path + page);
    this.service.GetDocPlanPage(path, page).subscribe(
      data => {
        this.docImages = new Array<string>();
        this.docImages.push(data);
        this.showImage((0));
      },
      error => { this.error = error }
    );
  }


  getUnIndexImage(path: string, page: number, push: boolean = true) {
    console.log("unindex path and page - " + path + page);
    this.service.GetDocPlanPage(path, page).subscribe(
      data => {
        if (push) {
          this.docImages.push(data);
          console.log('push ' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.shift();
            console.log('shift' + this.docImages.length);
            this.currentImageIndex = this.bufferSize;
          }
          else {
            this.currentImageIndex++;
          }
          console.log("unIndexImages and CII " + this.docImages.length + '-' + this.currentIndex + '-' + this.currentImageIndex);
        }
        else {
          this.docImages.splice(0, 0, data);
          console.log('splice' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.pop();
            console.log('pop' + this.docImages.length);
            this.currentImageIndex = 1;
          }
          else {
            this.currentImageIndex = 1;
          }
        }
        this.showImage((this.currentImageIndex - 1));
      },
      error => { this.error = error }
    );
  }

  /**
  * Search document for a book and page number entered by the user.
  * @param sBook
  * @param sPage
  */
  searchDocument(book: string, page: string) {

//    this.router.navigate(['/rec-bp-doc-disp-pg', book, page]);
    const url = this.router.createUrlTree(['/rec-bp-doc-disp-pg', book, page, 1])
    const tUrl = this.appurl + url.toString().substring(1);
    //if (loc == '1') {
    //  var params = [
    //    'height=' + screen.height,
    //    'width=' + screen.width,
    //    'fullscreen=yes' // only works in IE, but here for completeness
    //  ].join(',');

      var popup = window.open(tUrl, 'popup_window');
      popup.moveTo(0, 0);

  }


  searchDocument2(sBook: string, sPage: string) {
    this.isDocImageView = true;
    this.currentIndex = -1;
    this.currentImageIndex = 0;
    this.docImages.length = 0;
    this.service.GetIndexBPImagePath(sBook, "").subscribe(
      data => {
        console.log(data);
        this.planImages = data;
        if (this.planImages.length > 0) {
          for (var i = 0; i < this.planImages.length; i++) {
            if (this.planImages[i].includes(("0000" + sPage + "_").slice(-4))) {
              console.log("formatted" + ("0000" + sPage + "_").slice(-4));
              this.currentIndex = i + 1;
              console.log("CI" + this.currentIndex);
              break;
            }
          }
          if (this.currentIndex !== -1) {
            console.log("formatted" + ("0000" + sPage + "_").slice(-4));
            this.pageCount = this.planImages.length;
            this.sBook = sBook;
            this.sPage = sPage;
            this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0);
            this.changeNavigationbutton(this.pageCount);
            this.isLoadingImage = true;
            this.imageFound = true;
          }
          else {
            this.imageFound = false;
            this.pageCount = 0;
            this.currentIndex = 0;
          }
        }
      }
    )
  }

  getImageByBookPage(path: string, page: number, push: boolean = true) {
    console.log("current path and page" + path + page);
    this.service.GetDocPlanPage(path, page).subscribe(
      data => {
        if (push) {
          this.docImages.push(data);
          console.log('push' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.shift();
            console.log('shift' + this.docImages.length);
            this.currentImageIndex = this.bufferSize;

          }
          else {
            this.currentImageIndex++;
          }
          console.log("docimages and CII " + this.docImages.length + this.currentImageIndex);
        }
        else {
          this.docImages.splice(0, 0, data);
          console.log('splice' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.pop();
            console.log('pop' + this.docImages.length);
            this.currentImageIndex = 1;
          }
          else {
            this.currentImageIndex = 1;
          }
        }
        this.showImage((this.currentImageIndex - 1));
      },
      error => { this.error = error }
    );
  }

  showImage(idx: number) {

    this.currentImage = new Array<string>();

    this.isLoadingImage = true;
    if (this.currentImage.length === 1) {
      this.currentImage.pop();
    }
    this.currentImage.push(this.docImages[idx]);
    this.blobImage = this.docImages[idx];
    this.isLoadingImage = false;
    this.rePaintImgViewer();
  }

  /**
   * Navigate to previous page.
   * @param url
   */
  back(url) {
    this.nav.show();
    this.router.navigate([url]);
    //window.opener = 'Self';
    //window.open('', '_parent', '');
    //window.close();

  }

  showimgviewer() {
    this.showimageviewer = true;
    this.isImgVwVisible = false;
    this.changeImgVwVisible.emit(this.isImgVwVisible);
  }

  /**
   * Navigate to next page of a document.
   * @param event
   */
  getNextPg(event: Event) {

    this.currentIndex++;
    console.log("nxt pg CII " + this.currentImageIndex);
    if (this.docImages.length > this.currentImageIndex) {
      this.showImage(this.currentImageIndex);
      this.currentImageIndex++;
    }
    else {
      console.log(this.planImages[this.currentIndex - 1]);
      this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0, true);
    }

    this.changeNavigationbutton(this.pageCount);

  }

  /**
   * Navigate to previous page of a document.
   * @param event
   */
  getPrevPg(event: Event) {

    this.currentIndex--;
    if (this.currentImageIndex > 1) {
      this.showImage((this.currentImageIndex - 2));
      this.currentImageIndex--;
    }
    else {
      this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0, false);
    }
    this.changeNavigationbutton(this.pageCount);

  }

  checkIfFirstPage(): boolean {
    if (this.currentIndex == 1) {
      return true;
    }
    else
      return false;
  }
  checkIfLastPage(): boolean {
    if (this.currentIndex == this.pageCount) {
      return true;
    }
    else
      return false;
  }

  rePaintImgViewer() {
    //this.imgvwr = new ImageViewerComponent(this.renderer);
    //this.imgvwr.images = this.currentImage;
    //this.imgvwr.idContainer = "idOnHTML";
  
  }

  /**
   * Enable/Disable the navigation button, when its a first page or last page in the document.
   * @param pageCount
   */
  changeNavigationbutton(pageCount: number) {
    // Enable/disable navigation buttons.
    //console.log(this.book + "/" + this.page);
    console.log("Next doc page count" + this.pageCount)
    if (this.pageCount > 1) {
      if (this.currentIndex == 1) {
        this.isFirstPage = true;
        this.isLastPage = false;
        console.log("1");
      }
      else if (this.currentIndex == this.pageCount) {
        this.isLastPage = true;
        this.isFirstPage = false;
        console.log("2");
      }
      else {
        this.isLastPage = false;
        this.isFirstPage = false;
        console.log("3");
      }

    }

    else {
      this.isLastPage = true;
      this.isFirstPage = true;
      console.log("4");
    }

    console.log(this.isFirstPage);
    console.log(this.isLastPage);
  }

  /**
   * Navigate to First page in a document.
   * @param event
   */
  getFirstPg(event: Event) {
    console.log("firstpg" + this.pageCount);
    // Get first page from cache if present.
    if (this.currentIndex <= this.bufferSize && this.currentImageIndex !== 1) {
      this.currentIndex = 1;
      this.currentImageIndex = 1;
      this.showImage(this.currentImageIndex - 1);
      this.changeNavigationbutton(this.pageCount);
    }

    // get first page from service when its not present in cache.
    else {
      this.currentIndex = 1;
      this.currentImageIndex = 0;
      this.docImages.length = 0;
      this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0, true);
      this.changeNavigationbutton(this.pageCount);
    }
  }

  /**
   * Navigate to Last page in a document.
   * @param event
   */
  getLastPg(event: Event) {
    console.log("lastpg" + this.pageCount)
    let lastPgIdx: number = this.pageCount - 1;
    this.currentImageIndex = lastPgIdx;

    // Get last page from cache if present.
    if (this.pageCount <= this.bufferSize && this.docImages[lastPgIdx] != null) {
      this.currentImageIndex = this.pageCount - 1;
      this.currentIndex = this.pageCount;
      this.showImage(this.currentImageIndex);
      this.changeNavigationbutton(this.pageCount);
    }


    ////get last page from service when its not present in cache.
    else {
      this.currentImageIndex = 0;
      this.currentIndex = this.pageCount;
      this.docImages.length = 0;
      this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0, false);
      this.changeNavigationbutton(this.pageCount);
    }
  }


  allowDrop(ev) {
    console.log("allow drop");
    ev.preventDefault();
  }

  drag(ev) {
    console.log("drag");
    ev.dataTransfer.setData("text", ev.target.id);
  }

  drop(planImages, book, page, currentindex) {
    console.log("drop");
    console.log("planImages" + planImages + "book" + book + "page" + page + "currentindex" + currentindex);

    const index = this.docBasketChild.basketItems.findIndex(item => item.book === book && item.page === page && item.wholeDoc === false);
    if (index > -1) {
      if (this.docBasketChild.basketItems[index].pages.indexOf((currentindex - 1).toString()) > -1) {
        console.log("Duplicate entry");
        this.Message = "Plan Book/Page " + book + "/" + page + ", p." + (currentindex) + " is already added.";
        this.popupVisible = true;
      }
      else {
        this.docBasketChild.basketItems[index].pageCount = this.docBasketChild.basketItems[index].pageCount + 1;
        this.docBasketChild.basketItems[index].pages.push((currentindex - 1).toString());
        this.docBasketChild.basketItems[index].imagepaths.push(planImages[currentindex - 1]);
        console.log("Updated entry");
        this.Message = "Plan Book/Page " + book + "/" + page + ", p." + (currentindex) + " is added successfully.";
        this.popupVisible = true;
      }
    }

    else {
      this.basketItem = new basketVM();
      this.basketItem.document = 'B:' + book + '/P:' + page;
      this.basketItem.book = book;
      this.basketItem.page = page;
      this.basketItem.isEmail = false;
      this.basketItem.isDownload = false;
      this.basketItem.downloadAs = 'pdf';
      this.basketItem.wholeDoc = false;
      this.basketItem.pageCount = 1;
      this.basketItem.pages = new Array<string>((currentindex - 1).toString());
      this.basketItem.imagepaths = new Array<string>(planImages[currentindex - 1]);

      this.docBasketChild.basketItems.push(this.basketItem);
      //update local storage
      if (localStorage.getItem("planbasket") !== null && localStorage.getItem("planbasket").length > 0) {
        let basketls = JSON.parse(localStorage.getItem("planbasket"));
        basketls.push(this.basketItem);
        localStorage.setItem("planbasket", JSON.stringify(basketls));
      }

      console.log("Added entry");
      this.Message = "Plan Book/Page " + book + "/" + book + ", p." + (currentindex) + " is added successfully.";
      this.popupVisible = true;
    }
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.sbSvc.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.sbSvc.updateBasketCount(0);
  }

  toggleGo() {
    this.collapseGo = !this.collapseGo;
  }

  //toggleReturn() {
  //  this.collapseReturn = !this.collapseReturn;
  //}

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  //collapsesideinfo: boolean = false;

  //toggleSideInfo() {
  //  this.collapsesideinfo = !this.collapsesideinfo;
  //}

  //ItemClick(e) {
  //  if (e === null) {
  //    console.log('ItemClick fired and event is null');
  //  }
  //  else {
  //    console.log(`ItemClick fired: ${e.itemData}`);
  //    this.planname = e.itemData as string;
  //    console.log(`planname: ${this.planname}`);
  //    this.getCertPlanImage()

  //  }
  //}

  //getDirectoryImage() {
  //  this.service.GetIndexDirectoryImage(this.results[0].indexBook, this.results[0].indexGroup, this.results[0].indexPage, this.results[0].dateGroup).subscribe(
  //    data => {
  //      this.img = data
  //      console.log("img" + this.img);
  //    },
  //    error => { this.error = error }
  //  );
  //}

  getNextIdx(event: Event) {

    if (this.currentIndex == this.pageCount)
      return;
    else {
      this.currentIndex++;
      this.getUnIndexImage2(this.indexPaths[this.currentIndex - 1], 0);
    }

    //this.currentIndex++;
    //console.log("nxt idx CII " + this.currentImageIndex + " " + this.currentIndex);
    //if (this.docImages.length > this.currentImageIndex) {
    //  this.showImage(this.currentImageIndex);
    //  this.currentImageIndex++;
    //}
    //else {
    //  console.log('getunindeximg ' + this.indexPaths[this.currentIndex - 1]);
    //  //this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0, true);
    //  this.getUnIndexImage(this.indexPaths[this.currentIndex - 1], 0, true);
    //}

    this.changeNavigationbutton(this.pageCount);

  }

  getFirstIdx(event: Event) {

    if (this.currentIndex === 1)
      return;
    else {
      this.currentIndex = 1;
      this.getUnIndexImage2(this.indexPaths[this.currentIndex - 1], 0);
      this.changeNavigationbutton(this.pageCount);
    }
  }


  getLastIdx(event: Event) {

    if (this.currentIndex == this.pageCount)
      return;
    else {
      this.currentIndex = this.pageCount;
      this.getUnIndexImage2(this.indexPaths[this.currentIndex - 1], 0);
      this.changeNavigationbutton(this.pageCount);
    }
  }

  scrollToPage(page) {

    let pageNo = +page;
    if (pageNo > 0 && pageNo <= this.pageCount && pageNo != this.currentIndex) {
      this.currentIndex = pageNo;
      this.getUnIndexImage2(this.indexPaths[this.currentIndex - 1], 0);
      this.changeNavigationbutton(this.pageCount);
    }
  }
  
  /**
   * Navigate to previous page of a document.
   * @param event
   */
  getPrevIdx(event: Event) {

    if (this.currentIndex > 1) {
      this.currentIndex--;
      //console.log("prv idx CII " + this.currentImageIndex);
      this.getUnIndexImage2(this.indexPaths[this.currentIndex - 1], 0);
      this.changeNavigationbutton(this.pageCount);

    }
    //if (this.currentImageIndex > 1) {
    //  this.showImage((this.currentImageIndex - 2));
    //  this.currentImageIndex--;
    //}
    //else {
    //  //this.getImageByBookPage(this.planImages[this.currentIndex - 1], 0, false);
    //  this.getUnIndexImage(this.indexPaths[this.currentIndex], 0, false);
    //}
    //this.changeNavigationbutton(this.pageCount);

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }



}
